import { Component, OnInit, OnDestroy } from '@angular/core';
import { StepService } from '../../services/step.service';
import { SummaryService } from '../../../../services/summary.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TypeProduct } from 'src/app/utils/utils';
import { DataService } from 'src/app/services/data.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { ICampaignsTo } from '../../interfaces/catalogos.model';

@Component({
  selector: 'app-unidad-detail',
  templateUrl: './unidad-detail.component.html',
  styleUrls: ['./unidad-detail.component.scss']
})
export class UnidadDetailComponent implements OnInit, OnDestroy {

  isRecalculated = false;
  summary!: any;
  isBlocked: boolean = false;

  destroyBtn: boolean = false;

  obsIsRecalculated = new Subscription;
  obsLoading = new Subscription;
  obsDestroyBtn = new Subscription;
  obsBuroError = new Subscription;

  templateSuffix = environment.templateSuffix;
  public typeProduct = TypeProduct;

  isErrorBuro: boolean = false;
  isFlowB: boolean = false;
  paramsFord!: any;
  ruleFifteen: boolean = false;

  constructor(
    private readonly stepService: StepService,
    private readonly summaryService: SummaryService,
    private readonly router: Router,
    private readonly dataService: DataService,
    private readonly catalogsService: CatalogsService
  ) {
    this.summary = this.summaryService.summary;
    this.isFlowB = this.templateSuffix !== '';
  }

  ngOnInit(): void {
    this.obsIsRecalculated = this.stepService.isRecalculated.subscribe(resp => {
      this.isRecalculated = resp;
    });

    this.obsLoading = this.stepService.loading.subscribe(resp => {
      this.isBlocked = resp;
    });

    this.obsDestroyBtn = this.stepService.destroyBtn.subscribe(resp => {
      this.destroyBtn = resp;
    });

    this.obsBuroError = this.dataService.getSharedFunction().subscribe((data: boolean) => {
      this.isErrorBuro = data;
    });

    if (this.isFlowB) {
      this.getParamsFord(this.summary.car.idLeaseTech)
    }
  }

  changeCar() {
    this.router.navigate(['/buscador']);
  }

  ngOnDestroy(): void {
    this.obsDestroyBtn.unsubscribe();
    this.obsIsRecalculated.unsubscribe();
    this.obsLoading.unsubscribe();
    this.obsBuroError.unsubscribe();
  }

  isCredit(concept: string) {
    return concept === this.typeProduct.Traditional || concept === this.typeProduct.Ballon;
  }

  /**
    * Se utiliza para obtener los parametros de la campaña Ford
    * @param {number} idLeasetech
    * @memberof ConfigurationPanelComponent
    * @author victor.mendez
    * @date 2025-04-24
    */
  getParamsFord(idLeasetech: number): void {
    this.catalogsService.getParamsFord(idLeasetech).subscribe((resCar: ICampaignsTo) => {
      this.paramsFord = resCar;
      this.ruleFifteen = !!(this.summary.dataQuoter.engancheMax && this.paramsFord.cash_insurance);
    });
  }

}
